import {
  IMMUNIZATION_ID,
  SELECTED_HEADER_MENU,
  IS_GLOBAL_SEARCH,
  GET_GENDER,
  GET_ROLE,
  GET_REGION,
} from "../actions";

export const immunizationId = (state = false, action) => {
  switch (action.type) {
    case IMMUNIZATION_ID:
      return action.payload;
    default:
      return state;
  }
};

export const selectedHeaderMenu = (state = false, action) => {
  switch (action.type) {
    case SELECTED_HEADER_MENU:
      return action.payload;
    default:
      return state;
  }
};

export const isGlobalSearchReducer = (state = false, action) => {
  switch (action.type) {
    case IS_GLOBAL_SEARCH:
      return action.payload;
    default:
      return state;
  }
};

export const getGender = (state = false, action) => {
  switch (action.type) {
    case GET_GENDER:
      return action.payload;
    default:
      return state;
  }
};

export const getRole = (state = false, action) => {
  switch (action.type) {
    case GET_ROLE:
      return action.payload;
    default:
      return state;
  }
};

export const getRegion = (state = false, action) => {
  switch (action.type) {
    case GET_REGION:
      return action.payload;
    default:
      return state;
  }
};
